import React, { useEffect, useState } from 'react';
import { Tooltip, message } from 'antd';
import apis from '../../api';
import env from '@/env';

function RenderVideoName({ value, showStyle }) {
  const { categoryIds } = value;
  const [data, setData] = useState(value);
  useEffect(() => {
    value.id &&
      apis
        .HelpGetDocument({ id: value.id })
        .then((res) => {
          if (res && res.ret === '0') {
            if (showStyle === 4) {
              if (res.data.helpLiveVo) {
                // 直播视频取值
                setData({ ...value, ...(res.data.helpLiveVo || res.data.basicLiveVo) });
              }
            } else {
              if (res.data) {
                setData({ ...value, ...res.data });
              }
            }
          } else {
            message.error(res.msg);
          }
        })
        .catch((err) => {
          message.error(err);
        });
  }, [value, showStyle]);

  function gotoHelp(showStyle) {
    if (showStyle === 4) {
      window.open(`${env.ACORE_DOMAIN}/help/list/live/${categoryIds}?type=3`);
    }
    if (showStyle === 3) {
      window.open(`${env.ACORE_DOMAIN}/help/list/video/${categoryIds}?type=3`);
    }
  }

  return (
    <span className="help_center__title ellipsis-1-line" onClick={() => gotoHelp(showStyle)}>
      {data.title || data.name}
    </span>
  );
}

export default RenderVideoName;
